/**
 * Scrolls an element into view, one frame later so it exists in the DOM.
 *
 * The room for the fixed header comes from the global scroll-margin-top in styles.css, which the
 * browser applies to its own scrolls as well.
 *
 * @param target - CSS selector, or "#id" of the element to scroll to. Ids are looked up directly,
 * because block ids start with a digit and are therefore invalid as a selector.
 */
export function scrollToElement(target: string) {
	requestAnimationFrame(() => {
		const element = target.startsWith("#") ? document.getElementById(target.slice(1)) : document.querySelector(target);

		element?.scrollIntoView();
	});
}
